import { Link } from 'react-router-dom'
import { usePrinters, useDeletePrinter } from '../hooks/usePrinters'
import { formatMoney } from '../lib/format'

export default function PrintersPage() {
  const { data: printers, isLoading } = usePrinters()
  const deleteMutation = useDeletePrinter()

  if (isLoading) return <div style={{ padding: 'var(--space-6)' }}>Loading…</div>

  return (
    <div style={{ padding: 'var(--space-6)', maxWidth: 720 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 'var(--space-6)' }}>
        <h1>Printers</h1>
        <Link
          to="/settings/printers/new"
          style={{
            padding: 'var(--space-2) var(--space-4)',
            background: 'var(--color-primary)',
            color: 'white',
            borderRadius: 'var(--radius-md)',
            fontWeight: 600,
            fontSize: 'var(--font-size-sm)',
            textDecoration: 'none',
          }}
        >
          + Add printer
        </Link>
      </div>

      {!printers || printers.length === 0 ? (
        <div style={{
          padding: 'var(--space-8)',
          textAlign: 'center',
          background: 'var(--color-surface)',
          borderRadius: 'var(--radius-lg)',
          color: 'var(--color-text-muted)',
        }}>
          No printers yet.
        </div>
      ) : (
        <ul>
          {printers.map((p) => (
            <li
              key={p.id}
              style={{
                background: 'var(--color-surface)',
                padding: 'var(--space-4)',
                borderRadius: 'var(--radius-lg)',
                marginBottom: 'var(--space-3)',
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 'var(--font-size-lg)' }}>{p.name}</div>
                  <div style={{ color: 'var(--color-text-muted)', fontSize: 'var(--font-size-sm)' }}>
                    {formatMoney(p.purchase_cost)} · {p.status}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 'var(--space-3)' }}>
                  <Link
                    to={`/settings/printers/${p.id}`}
                    style={{ color: 'var(--color-primary)', fontSize: 'var(--font-size-sm)', fontWeight: 600 }}
                  >
                    Edit
                  </Link>
                  <button
                    onClick={() => {
                      if (window.confirm(`Delete printer "${p.name}"? This cannot be undone.`)) {
                        deleteMutation.mutate(p.id)
                      }
                    }}
                    style={{ color: 'var(--color-danger)', fontSize: 'var(--font-size-sm)', fontWeight: 600 }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
